module.exports = __webpack_public_path__ + "5b64272308352f9954c5ee5a1561d14c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/placeholder-128.jpg
// module id = ./assets/images/placeholder-128.jpg
// module chunks = 0